import { Injectable } from '@angular/core';
import { SensorObject } from '../asp/SensorObject';
import { MatDialog, MatDialogRef, MatDialogState } from '@angular/material/dialog';
import { SensorBiasComponent } from './sensor-bias.component';
import { AlertPolygonDialogComponent } from '@core_n/alert-polygon/alert-polygon.component';
import * as projEnums from '../../app/common/projEnums';
import * as projMsgs from '../../app/msg/projMsgs';
import { MsgBoxService } from '@core_n/msg-boxes/msg-box.service';
import { AlertPolygonObject } from './../../core/app/alert-polygon/alert-polygon.component';
import { IAro, AppInjector } from '../../core/app/common/inject';
import { UserActionService } from '@core_n/user-action/user-action.service';

@Injectable({
  providedIn: 'root'
})
export class SensorBiasService {

  private dialogRef: MatDialogRef<any>;
  
  constructor(private dialog: MatDialog, protected msgBox: MsgBoxService) {
  }
  
  showSensorBias(sensor: SensorObject) {
    if (this.dialogRef && this.dialogRef.getState() == MatDialogState.OPEN) {
      let sensorBiasComp = this.dialogRef.componentInstance as SensorBiasComponent;
      sensorBiasComp.setSensor(sensor);
      sensorBiasComp.dialogRaise();
    }
    else {
      this.dialogRef = this.dialog.open(SensorBiasComponent, SensorBiasComponent.createDialogConfig(sensor));
    }
  }

  async showNatNai(sensor: SensorObject, operationAction: number) {
    if (operationAction == projEnums.NatNaiOperationAction.Delete)
    {
      let confirmed = await this.msgBox.showConfirmMsgBox("Are you sure you want to delete?", "Delete Nat Nai", "Yes", "No");
      if (!confirmed)
        return;      

      let alertPolygonObj: AlertPolygonObject = new AlertPolygonObject();
      let obj = new projMsgs.Nai();
      alertPolygonObj.Sic = sensor.sic;
      alertPolygonObj.Sac = sensor.sac;
      alertPolygonObj.NaiNatId = sensor.naiNatAreaObject.naiNatId;
      alertPolygonObj.OperationAction = projEnums.NatNaiOperationAction.Delete;
      obj.AlertPolygonObj = alertPolygonObj;
      obj.AlertPolygonObj.NaiOrNat = sensor.naiNatAreaObject.naiOrNat;
      AppInjector.get(UserActionService).sendUserAction(obj);
    }
    else if (this.dialogRef && this.dialogRef.getState() == MatDialogState.OPEN) {
      let natNaiDialog = this.dialogRef.componentInstance as AlertPolygonDialogComponent;
      natNaiDialog.setSensorNatNai(sensor, operationAction);
      natNaiDialog.dialogRaise();
    }
    else {
      this.dialogRef  = this.dialog.open(AlertPolygonDialogComponent, AlertPolygonDialogComponent.createDialogConfig(50));
      this.dialogRef.componentInstance.setSensorNatNai(sensor, operationAction);
    }
  }

}
